import { createFileRoute } from '@tanstack/react-router';
import { TenantContext } from '@interxfi/api-client';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { UserauthRealmsTable } from '../../../../../../features/userauth/realm/userauth-realms-table';
import type { RouteGuardOptions } from '../../../../../../util/routing/guard';
import { getPageHead } from '../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_platform/_context-required/realm/_realm/')({
  staticData: {
    guard: { access: { allowedTenantTypes: [TenantContext.Platform] } },
  } as const satisfies RouteGuardOptions,
  shouldReload: true,
  preload: false,
  head: () => getPageHead('Realms'),
  component: RealmList,
});

function RealmList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <UserauthRealmsTable />
      </PageLayout.Section>
    </PageLayout>
  );
}
